<script setup lang="ts">
	import { ref } from 'vue';
	import { SortableItem, useSortableItem } from './SortableItem.js'
	
	const props = defineProps({
		id: String,
		items: Array
	});
	
	const {	previewItem } = useSortableItem();
	
	const startIndex = ref(-1);
	const actualIndex = ref(-1);
	
	
	const list = ref(props.items);
	
	const emit = defineEmits(['removeFrom']);
	defineExpose({removeFrom,removePreview});
	
	function onStartDrag(evt, item: SortableItem, index: number): void {
		//start transfer
		item.fromList=props.id;
		item.index=index;
		evt.dataTransfer.dropEffect = 'move';
		evt.dataTransfer.effectAllowed = 'move';
		evt.dataTransfer.setData('item', JSON.stringify(item));
		actualIndex.value=index;
		startIndex.value=index;
		//console.log("starting index:"+index);
		requestAnimationFrame(function() {
			evt.target.classList.add('hide'); 
		});
    }
	
	function onEnterDrag(evt, index: number): void {
		actualIndex.value = index;
		removePreview();
		if (startIndex.value<0 || actualIndex.value<startIndex.value || actualIndex.value>startIndex.value+1) {
			addTo(previewItem(),index);
		}
	}
	
    function onDrop(evt): void {
		const item: SortableItem = JSON.parse(evt.dataTransfer.getData('item'));
		if (item.fromList!==props.id || item.index!==actualIndex.value) {
			removeFrom(item);
			//correct removed item with lower index
			if (item.index<actualIndex.value && actualIndex.value<list.value.length) {
				actualIndex.value=actualIndex.value-1;
			}
			addTo(item,actualIndex.value);
		}
		actualIndex.value=-1;
		startIndex.value=-1;
		evt.target.classList.remove('hide');
    }	
	
	function onEndDrag(evt): void {
		evt.srcElement.classList.remove('hide');
	}
	
	function removeFrom(item: SortableItem): void {
		removePreview();
		if (item.fromList===props.id) { //remove from this list
			console.log("Femoving item:"+item.id+" from list:"+item.fromList);
			list.value = list.value.filter((row)=>{return row.id!==item.id});
			startIndex.value=-1;
		}
		else { //remove from another list
			let cloneItem: SortableItem = Object.assign({}, item);
			emit('removeFrom',cloneItem);
		}
	}
	
	function removePreview(resetStartIndex?: boolean): void {
		//console.log("removing preview for:"+props.id);
		if (resetStartIndex) {
			startIndex.value=-1;
		}
		list.value = list.value.filter((row)=>{return !row.preview});
	}
	
	function addTo(item: SortableItem, index: number): void {
		//console.log("adding to list item:"+item.id);
		item.fromList=null;
		if (index>=0) {
			list.value.splice(index, 0, item);
		}
		else {
			list.value.push(item);
		}
    }
	
</script>
<template>
	<div @drop="onDrop($event)" :title="title" @dragover.prevent @dragenter.prevent @dragend="onEndDrag($event)" >
      <div :id="'list'+item.id" v-for="(item,index) in list" :key="item.id" 
		   :class="{'sortingPreview':item.preview}"
			draggable="true" @dragstart="onStartDrag($event, item, index)" 
			@dragenter="onEnterDrag($event, index)" >
        {{ item.name }}&nbsp;
      </div>
    </div>
</template>

<style>
	.sortingBlock .sortingPreview {
		background-color: var(--input-bg);
		color: var(--input-bg);
	}
	
	.sortingBlock div {
		width: calc(100% - 4px);
		margin: 2px 2px;
		cursor: move;
		background-color: var(--bg);
		color: var(--fg);
		padding: 4px 6px 4px 6px;
		box-sizing: border-box;
		font-weight: normal;
		line-height: 18px;
		border-radius: var(--button-radius);
	}
	
	.sortingBlock div img {
		width: 18px;
		height: 18px;
		vertical-align: top;
	}
	
	.sortingBlock .hide {
		background-color: var(--pill-selected-bg);
		color: var(--pill-selected-fg);
		opacity: 0.5;
	}
</style>
